import axios from "axios";
import { Api } from "./ApiRoutes.js";
import { BASE_URL } from "./ApiRoutes.js";

export const getAllListingData = async () => {
  return await axios.get(`${BASE_URL}${Api.programme.getAllProgrammeList}`);
};

export const getCategoryProgrammeById = async (id) => {
  return await axios.get(
    `${BASE_URL}${Api.programme.getCategoryByInProgramme}${id}`
  );
};

export const getProgrammeDetailsById = async (id) => {
  return await axios.get(
    `${BASE_URL}${Api.programme.getProgrammeDetaileById}${id}`
  );
};

export const addProgrammeApplication = async (data) => {
  return await axios.post(
    `${BASE_URL}${Api.programme.addProgrammeApplication}`,
    { ...data }
  );
};
export const uploadFileAws = async (body) => {
  return await axios.post(`${BASE_URL}${Api.programme.uploadFile}`, body);
};

export const getAllJob = async () => {
  return await axios.get(`${BASE_URL}${Api.jobs.getAllJobList}`);
};

export const getJobDetailsById = async (id) => {
    return await axios.get(`${BASE_URL}${Api.jobs.getJobDetailById}${id}`);
}

export const userSignUp = async(body)=>{
    return await axios.post(`${BASE_URL}${Api.auth.userSignUp}`,body);
}
